<template>
  <div class="login__description__content">
    <img
      class="image-with-text__image login__description__content__image"
      src="../assets/images/svg/login-description-image.svg"
      alt="image"
    />
  </div>
</template>

<script setup></script>
